import { ArrowForward } from '@mui/icons-material';
import HelpIcon from '@mui/icons-material/Help';
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import type { HelpPageDetail } from '/@/hooks/help-center';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const HelpCenterRelatedQuestions = ({ page }: { page: HelpPageDetail }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const goToArticle = useCallback(
        (articleSlug: string) => {
            navigate(reverse('helpCenter.Article', { params: { slug: articleSlug } }));
        },
        [navigate]
    );

    return (
        <Stack
            spacing={1.5}
            sx={{
                width: { xs: '100%', lg: 300 },
                flexShrink: 0,
                position: { lg: 'sticky' },
                top: { lg: 96 },
            }}
        >
            <Stack direction='row' alignItems='center' spacing={1}>
                <HelpIcon sx={{ color: 'primary.main', fontSize: 24 }} />
                <Typography color='primary' variant='h6'>
                    {_('Preguntas relacionadas')}
                </Typography>
            </Stack>
            <Stack spacing={1}>
                {(page.relatedQuestions ?? []).map((rq, index) => (
                    <Box
                        key={rq.id}
                        component='button'
                        type='button'
                        onClick={() => goToArticle(rq.slug)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            p: 2,
                            m: 0,
                            width: '100%',
                            textAlign: 'left',
                            cursor: 'pointer',
                            bgcolor: 'background.paper',
                            border: '1px solid',
                            borderColor: theme.palette.divider,
                            borderRadius: 0,
                            '&:hover': { borderColor: theme.palette.gray[800] },
                        }}
                    >
                        <Typography color='primary' variant='subtitle1' fontWeight='500'>
                            {_(rq.title)}
                        </Typography>
                        <ArrowForward sx={{ color: 'primary.main', flexShrink: 0, width: 24, height: 24 }} />
                    </Box>
                ))}
            </Stack>
        </Stack>
    );
};

export default HelpCenterRelatedQuestions;
